import React, { createContext, ReactNode, useContext, useMemo } from 'react'

import { useFormikContext } from 'formik'

import { Form } from '../../../ana-toolbox'

export type FormValueProviderProps = Partial<Form>

const Context = createContext({} as FormValueProviderProps)

/* This provider gets some functions from formik context
 * memoize, and provide them. It's built to fix some performance issues
 * due to the high amount of Formik updates.
 */
export const FormValueProvider = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const formikContext = useFormikContext<Partial<Form>>()
  const value = useMemo(() => formikContext?.values ?? {}, [formikContext?.values])

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useFormValue = () => {
  const context = useContext(Context)

  return context
}
